<label *ngIf="item && item.cells" [ngStyle]="getStyle()"
       matTooltip="{{item.cells[statusTooltipKey] ? (item.cells[statusTooltipKey].displayText? item.cells[statusTooltipKey].displayText : item.cells[fieldDefinition.key].displayText) : ''}}">
  <i [ngClass]="status.tags[2]" [ngStyle]="{'color': this.status.tags[1]}"></i> <span>{{status ? status.text : ''}}</span>

</label>
